export default __webpack_public_path__ + "b1c7637179aed915741bf115e6120129.jpg";